import { useAsyncData, useNuxtData } from '#app'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { omit } from '@backmarket/utils/object/omit'

export function useSkinnyBannerLoader() {
  const $httpFetch = useHttpFetch()

  /**
   * fetches skinny banner data from the API and loads it in Nuxt cache
   */
  const loadSkinnyBannerData = () =>
    useAsyncData(
      'skinny-banners',
      () => $httpFetch('/bm/branding/skinny-banner'),
      {
        getCachedData: (key) => {
          return useNuxtData(key).data.value || undefined
        },
      },
    )

  function useLoadedData(page: string, id?: number | null) {
    const { data } = loadSkinnyBannerData()

    return computed(() => {
      let banners = (data.value || []).filter(({ locations = [] }) =>
        locations.includes(page),
      )
      if (id) {
        banners = banners.filter(({ id: bannerId }) => bannerId === id)
      }

      const [bannerToDisplay = null] = banners

      return bannerToDisplay ? omit(bannerToDisplay, ['locations', 'id']) : null
    })
  }

  const load = loadSkinnyBannerData

  return {
    load,
    useLoadedData,
  }
}
